import { GraphqQlApi as api } from '../api/api.js'

export default {
  state: {
    processing: false,
    error: null,
    notify: null,
    downloadedLocales: [],
    globalSearch: '',
    showModal: false,
    overlayText: '',
    dataSources: {},
    needRefreshApp: false,
    appVersion: null,
    isApplicationNotFound: false
  },
  mutations: {
    SET_PROCESSING: (state, payload) => {
      state.processing = payload
    },
    SET_ERROR: (state, payload) => {
      state.error = payload
    },
    CLEAR_ERROR: (state) => {
      state.error = null
    },
    SET_NOTIFY (state, notify) {
      state.notify = notify
    },
    SET_LOCALIZATION(state, value) {
      state.downloadedLocales.push(value)
    }, 
    SET_GLOBAL_SEARCH(state, value) {
      state.globalSearch = value
    },
    SET_SHOW_MODAL(state, value) {
      state.showModal = value
    },
    SET_OVERLAY_TEXT(state, value) {
      state.overlayText = value
    },
    ADD_DATASOURCE_TO_POOL(state, {value, id}) {
      state.dataSources[id] = value
    },
    SET_NEED_REFRESH_APP(state, { needRefreshApp }) {
      state.needRefreshApp = needRefreshApp
    },
    SET_APP_VERSION(state, { version }) {
      state.appVersion = version
    },
    SET_APPLICATION_NOT_FOUND_STATUS(state, value) {
      state.isApplicationNotFound = value
    }
  },
  getters: {
    getProcessing(state) {
      return state.processing
    },
    getError(state) {
      return state.error
    }
  },
  actions: {
    async changeLocaleAsync({ dispatch, commit, state  }, value) {
      if (state.downloadedLocales.find(x => x === value)) {
        return { status: false }
      }

      const { systemLocalization, userLocalization } = await dispatch('getLocalizationAsync')
      commit('SET_LOCALIZATION', value)
      
      return  {
        status: true, 
        systemLocalization,
        userLocalization
      }
    },

    async getLocalizationAsync(context) {
      context.commit('SET_PROCESSING', true)
      const getLocalization = async function (id) {
        // localization for system model with all modules, and user model
        let response = null
        try {
          response = await api.getComplexLocalizationAsync({ id, moduleIds: context.rootState.appRunner.moduleIds })
        } catch (err) {
          // try get system and user localization
          try {
            response = await api.getFullLocalizationAsync({ id })
          } catch (er) {
            console.warn('Getting localization from api - failed. GraphQL is old. Switch to use old way.')
            response = await api.getLocalizationAsync({ id })
          }
        }

        return response
      }

      const response = await getLocalization(context.rootState.appRunner.model.$ID)
      context.commit('SET_PROCESSING', false)
      const parseLocalization = function (stringLocalization) {
        if (!stringLocalization) {
          return {}
        }

        let localization = null
        try {
          localization = JSON.parse(stringLocalization)
        } catch (err) {
          localization = {}
        }

        return localization
      }
      
      return {
        systemLocalization: parseLocalization(response?.data?.webAppModelerQuery?.getLocalization?.localization),
        userLocalization: parseLocalization(response?.data?.webAppModelerQuery?.getLocalization?.userLocalization)
      }
    }
  }
}
